import React, { useMemo } from 'react';
import Grid from '@mui/material/Grid2';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';

function formatHours(hours) {
  if (typeof hours !== 'number' || isNaN(hours)) return '-';
  const h = Math.floor(hours);
  const m = Math.round((hours - h) * 60);
  return `${h}:${String(m).padStart(2, '0')}`;
}

export default function TopKPIs({ data = [] }) {
  const metrics = useMemo(() => {
    const total = data.length;
    let sumTime = 0;
    let timeCount = 0;
    const optionCounts = {};
    let sumTarget = 0;
    let targetCount = 0;

    data.forEach(r => {
      if (r && typeof r === 'object') {
        const t = r.userSelectedTime;
        const tnum = typeof t === 'string' ? parseFloat(t) : t;
        if (typeof tnum === 'number' && !isNaN(tnum)) { sumTime += tnum; timeCount++; }
        const opt = (r.option_name || 'unknown');
        optionCounts[opt] = (optionCounts[opt] || 0) + 1;
        if (typeof r.targetSoc === 'number') { sumTarget += r.targetSoc; targetCount++; }
      }
    });

    const avgTime = timeCount ? (sumTime / timeCount) : null;
    const avgTarget = targetCount ? (sumTarget / targetCount) : null;
    const topOption = Object.entries(optionCounts).sort((a,b)=>b[1]-a[1])[0]?.[0] || 'N/A';

    return {
      total,
      avgTime,
      topOption,
      avgTarget
    };
  }, [data]);

  return (
    <Grid container spacing={2} columns={12} sx={{ mb: 2 }}>
      <Grid size={{ xs: 12, md: 3 }}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="overline">Total Requests</Typography>
            <Typography variant="h5">{metrics.total}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="overline">Avg Selected Time</Typography>
            <Typography variant="h5">{metrics.avgTime ? formatHours(metrics.avgTime) : '-'}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="overline">Top Option</Typography>
            <Typography variant="h5">{metrics.topOption}</Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ xs: 12, md: 3 }}>
        <Card variant="outlined">
          <CardContent>
            <Typography variant="overline">Avg Target SOC</Typography>
            <Typography variant="h5">{metrics.avgTarget ? `${metrics.avgTarget.toFixed(0)}%` : '-'}</Typography>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
